import React from 'react';
import {
  ArrowDownCircle,
  ArrowUpCircle,
  ClipboardCheck,
  FileText,
  Percent,
  RefreshCw,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { CreditActionKind } from './CreditLoanActionModals';

export interface CreditLifecycleAction {
  kind: CreditActionKind;
  title: string;
  Icon: LucideIcon;
  color: string;
}

/** Shared, ordered servicing surface for PC and LL. The modal behind an action
 * remains domain-specific, but operators see the same commands in the same
 * order and with the same interaction treatment. */
export const CORE_CREDIT_LIFECYCLE_ACTIONS: CreditLifecycleAction[] = [
  { kind: 'paydown', title: 'Paydown', Icon: ArrowDownCircle, color: '#34d399' },
  { kind: 'drawdown', title: 'Drawdown', Icon: ArrowUpCircle, color: '#818cf8' },
  { kind: 'rate-reset', title: 'Rate reset', Icon: RefreshCw, color: '#7dd3fc' },
  { kind: 'interest', title: 'Interest / Fee', Icon: Percent, color: '#6ee7b7' },
  { kind: 'amend', title: 'Amend', Icon: FileText, color: '#c4b5fd' },
  { kind: 'covenant-test', title: 'Record covenant test', Icon: ClipboardCheck, color: '#67e8f9' },
];

export const CreditLifecycleActionButton: React.FC<{
  action: CreditLifecycleAction;
  onClick: () => void;
  disabled?: boolean;
  showLabel?: boolean;
}> = ({ action, onClick, disabled = false, showLabel = false }) => (
  <span style={{ position: 'relative', display: 'inline-flex' }}>
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={action.title}
      title={action.title}
      style={{
        background: showLabel ? 'transparent' : `${action.color}18`,
        border: `1px solid ${showLabel ? '#334155' : action.color + '55'}`,
        color: showLabel ? '#e2e8f0' : action.color,
        padding: showLabel ? '0.55rem 0.75rem' : '0.3rem 0.45rem',
        borderRadius: 6,
        cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        opacity: disabled ? 0.45 : 1,
      }}
    >
      <action.Icon size={13} />
      {showLabel && <span>{action.title}</span>}
    </button>
  </span>
);
